import { Box, styled } from "@mui/material";

interface INavigationProps {
  className?: string;
  isMobile: boolean;
}

export const HeaderWrapper = styled(Box)`
  padding-top: 40px;
  text-align: center;

  & [class*="customer-header"] {
    margin: 20px 0;
    & > * {
      margin-bottom: 15px;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
    & [class*="customer-header-email"] {
      font-weight: 400;
      font-size: 14px;
    }

    & [class*="customer-since"] {
      font-size: 10px;
      font-weight: 400;
      text-transform: uppercase;
    }
  }

  @media screen and (max-width: 600px) {
    & [class*="customer-header"] {
      margin: 20px 0 0 0;
    }
  }
`;

export const Navigation = styled(Box, { shouldForwardProp: prop => prop !== "isMobile" })<INavigationProps>`
  align-items: center;
  background: ${props => props.theme.modernMenuBackground};
  display: flex;
  height: 56px;
  justify-content: center;
  position: relative;
  z-index: 2;
  & ul {
    -ms-overflow-style: none;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    padding: 15px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    & li {
      font-size: ${props => props.theme.modernSubHeadingFontSize}px;
      font-weight: ${props => props.theme.modernSubHeadingFontWeight};
      list-style: none;
      margin: 15px;
      text-transform: uppercase;
      white-space: nowrap;
      & a {
        color: ${props => props.theme.modernSubHeadingFontColor};
        text-decoration: none;
        transition: 0.3s;
        &:visited,
        &:hover,
        &:focus {
          color: ${props => props.theme.modernSubHeadingFontColor};
        }
        &.active {
          text-decoration: underline;
        }
      }
    }
  }
  ${props =>
    props.isMobile &&
    `
    border-top:.5px solid ${props.theme.modernLineDividers};
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    width: 100%;
  `}
`;
